import { API_PREFIX } from '../constants/app.js';

export const API_ROUTES = {
  HEALTH: `${API_PREFIX}/health`,

  AUTH: {
    REGISTER: `${API_PREFIX}/auth/register`,
    LOGIN: `${API_PREFIX}/auth/login`,
    GUEST: `${API_PREFIX}/auth/guest`,
    LOGOUT: `${API_PREFIX}/auth/logout`,
    REFRESH: `${API_PREFIX}/auth/refresh`,
    ME: `${API_PREFIX}/auth/me`,
    GOOGLE: `${API_PREFIX}/auth/google`,
    FORGOT_PASSWORD: `${API_PREFIX}/auth/forgot-password`,
    RESET_PASSWORD: `${API_PREFIX}/auth/reset-password`,
  },

  USERS: {
    BASE: `${API_PREFIX}/users`,
    BY_ID: (id: string) => `${API_PREFIX}/users/${id}`,
    PROFILE: (username: string) => `${API_PREFIX}/users/profile/${username}`,
    SEARCH: `${API_PREFIX}/users/search`,
    AVATAR: `${API_PREFIX}/users/avatar`,
  },

  ROOMS: {
    BASE: `${API_PREFIX}/rooms`,
    BY_ID: (id: string) => `${API_PREFIX}/rooms/${id}`,
    BY_CODE: (roomCode: string) => `${API_PREFIX}/rooms/code/${roomCode}`,
    JOIN: (id: string) => `${API_PREFIX}/rooms/${id}/join`,
    LEAVE: (id: string) => `${API_PREFIX}/rooms/${id}/leave`,
    INVITE: (id: string) => `${API_PREFIX}/rooms/${id}/invite`,
    TRANSFER_HOST: (id: string) => `${API_PREFIX}/rooms/${id}/transfer-host`,
    REMOVE_PARTICIPANT: (roomId: string, userId: string) =>
      `${API_PREFIX}/rooms/${roomId}/participants/${userId}/remove`,
    MY_ROOMS: `${API_PREFIX}/rooms/me`,
  },

  MATCHES: {
    BASE: `${API_PREFIX}/matches`,
    BY_ID: (id: string) => `${API_PREFIX}/matches/${id}`,
    LIVE: `${API_PREFIX}/matches/live`,
    UPCOMING: `${API_PREFIX}/matches/upcoming`,
    FINISHED: `${API_PREFIX}/matches/finished`,
    SEARCH: `${API_PREFIX}/matches/search`,
    TEAMS: `${API_PREFIX}/matches/teams`,
    TEAM: (id: string) => `${API_PREFIX}/matches/teams/${id}`,
    EVENTS: (id: string) => `${API_PREFIX}/matches/${id}/events`,
    STATISTICS: (id: string) => `${API_PREFIX}/matches/${id}/statistics`,
    LINEUPS: (id: string) => `${API_PREFIX}/matches/${id}/lineups`,
    COMPETITIONS: `${API_PREFIX}/matches/competitions`,
    COMPETITION: (slug: string) => `${API_PREFIX}/matches/competitions/${slug}`,
    STANDINGS: (slug: string) => `${API_PREFIX}/matches/competitions/${slug}/standings`,
    FAVORITES: `${API_PREFIX}/matches/favorites`,
    FAVORITE: (id: string) => `${API_PREFIX}/matches/favorites/${id}`,
    ROOM_FIXTURE: (roomId: string) => `${API_PREFIX}/matches/rooms/${roomId}/fixture`,
    LINK_ROOM: (roomId: string) => `${API_PREFIX}/matches/rooms/${roomId}/link`,
    SYNC: (roomId: string) => `${API_PREFIX}/matches/sync/${roomId}`,
  },

  CHAT: {
    MESSAGES: (roomId: string) => `${API_PREFIX}/chat/${roomId}/messages`,
    MESSAGE: (roomId: string, messageId: string) =>
      `${API_PREFIX}/chat/${roomId}/messages/${messageId}`,
  },

  COLLABORATION: {
    MESSAGES: (roomId: string) => `${API_PREFIX}/collaboration/${roomId}/messages`,
    MESSAGE: (roomId: string, messageId: string) =>
      `${API_PREFIX}/collaboration/${roomId}/messages/${messageId}`,
    POLLS: (roomId: string) => `${API_PREFIX}/collaboration/${roomId}/polls`,
    POLL_VOTE: (roomId: string, pollId: string) =>
      `${API_PREFIX}/collaboration/${roomId}/polls/${pollId}/vote`,
    PREDICTIONS: (roomId: string) => `${API_PREFIX}/collaboration/${roomId}/predictions`,
    TIMELINE: (roomId: string) => `${API_PREFIX}/collaboration/${roomId}/timeline`,
    ANNOUNCEMENTS: (roomId: string) => `${API_PREFIX}/collaboration/${roomId}/announcements`,
  },

  FRIENDS: {
    BASE: `${API_PREFIX}/friends`,
    REQUEST: `${API_PREFIX}/friends/request`,
    ACCEPT: (id: string) => `${API_PREFIX}/friends/${id}/accept`,
    DECLINE: (id: string) => `${API_PREFIX}/friends/${id}/decline`,
    REMOVE: (id: string) => `${API_PREFIX}/friends/${id}`,
    BLOCK: (id: string) => `${API_PREFIX}/friends/${id}/block`,
    PENDING: `${API_PREFIX}/friends/pending`,
  },

  NOTIFICATIONS: {
    BASE: `${API_PREFIX}/notifications`,
    READ: (id: string) => `${API_PREFIX}/notifications/${id}/read`,
    READ_ALL: `${API_PREFIX}/notifications/read-all`,
    UNREAD_COUNT: `${API_PREFIX}/notifications/unread-count`,
    PUSH_SUBSCRIBE: `${API_PREFIX}/notifications/push/subscribe`,
    PUSH_VAPID_KEY: `${API_PREFIX}/notifications/push/vapid-key`,
  },

  OPS: {
    LIVE: `${API_PREFIX}/ops/live`,
    READY: `${API_PREFIX}/ops/ready`,
    METRICS: `${API_PREFIX}/ops/metrics`,
    ADMIN_DASHBOARD: `${API_PREFIX}/ops/admin/dashboard`,
  },

  REACTIONS: {
    STATS: (roomId: string) => `${API_PREFIX}/reactions/${roomId}/stats`,
    HISTORY: (roomId: string) => `${API_PREFIX}/reactions/${roomId}/history`,
  },
} as const;

export type ApiRoute = typeof API_ROUTES;
